import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute = ({ children }: AdminRouteProps) => {
  const { auth } = useAuth();
  const location = useLocation();
  
  // Mostrar pantalla de carga mientras se inicializa la autenticación
  if (auth.isLoading || !auth.initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  
  // Verificar si el usuario está autenticado y tiene rol de admin o beeadmin
  if (!auth.isAuthenticated) {
    // Redirigir al login si no está autenticado
    return <Navigate to={`/login?redirect=${location.pathname}`} state={{ from: location }} replace />;
  }
  
  // Verificar si tiene los permisos necesarios
  if (auth.user?.role !== 'admin' && auth.user?.role !== 'beeadmin') {
    // Redirigir a la página de cuenta si no tiene permisos
    return <Navigate to="/account" replace />;
  }
  
  return <>{children}</>;
};

export default AdminRoute; 